import { SET_LOCATIONS, Locations, LocationsActionTypes } from '../../types/LocationTypes';

export const setLocations = (locations: Locations): LocationsActionTypes => ({
  type: SET_LOCATIONS,
  payload: locations,
});
